import { FileText } from "lucide-react";
import {
  PROPERTY_STATUS_LABEL,
  PropertyStatus,
} from "../../global/propertyStatus";

interface IProps {
  status: PropertyStatus;
}

function DraftBadge({ status }: IProps) {
  return (
    <span className="inline-flex w-fit items-center gap-1 rounded-full border border-slate-200 bg-slate-100 px-2.5 py-0.5 text-xs font-semibold text-slate-700">
      <FileText className="h-3.5 w-3.5 text-slate-600" aria-hidden />
      {PROPERTY_STATUS_LABEL[status]}
    </span>
  );
}

export default DraftBadge;
